import { defineStore } from 'pinia';
import { mergeStores } from '@/store/helpers';
import mdSnapshotSearchConfig from './config';
import mdSearchConfig from '../../md-search/_store/config';
import mdSearchBarConfig from '../../md-search-bar/_store/config';

export default (storeName, $pinia) => defineStore(storeName, mergeStores(mdSnapshotSearchConfig, mdSearchConfig, mdSearchBarConfig($pinia)));
